exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".breadcrum-label-style {\n  word-wrap: none !important;\n  word-break: inherit !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/BreadCrumbs/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/BreadCrumbs/index.css
// module chunks = 504